import { InjectionToken } from '@angular/core';

export const INTEGRATIONS_FEATURE_FLAGS = new InjectionToken<Record<string, boolean>>(
  'integrations feature flags',
);
